import type { Answer } from "@pulse/api/answersAPI";
import type { Question } from "@pulse/api/surveyApi";
import { createContext } from "react";

export const QuestionContext = createContext<{
    question: Question;
    answers: Answer[];
    answersWithComments: Answer[];
    questionIndex: number;
} | null>(null);
